export default __webpack_public_path__ + "static/slider-img-1-0a4b23d094e4b71e049e1508085b7958.jpg";